export default function hBridge(h) {
    // Create bridge to createElement method for React
    return (tag, attrs, ...rest) => h(tag, { attrs }, rest);
}
